import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { Subscription } from 'rxjs';
import {
  InfoModalData,
  InfoModalService,
} from '../../services/info-modal.service';

@Component({
  selector: 'app-info-modal',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule],
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.scss'],
})
export class InfoModalComponent implements OnDestroy {
  showDialog: boolean = false;
  modalData: InfoModalData | null = null;
  private subscriptions: Subscription = new Subscription();

  constructor(private infoModalService: InfoModalService) {
    const modalVisibleSub = this.infoModalService.isModalVisible$.subscribe(
      (isVisible) => {
        this.showDialog = isVisible;
      },
    );
    this.subscriptions.add(modalVisibleSub);

    const modalDataSub = this.infoModalService.modalData$.subscribe(
      (modalData) => {
        this.modalData = modalData;
      },
    );
    this.subscriptions.add(modalDataSub);
  }

  closeModal = () => {
    const onCloseCallback = this.modalData?.onClose;

    this.infoModalService.hide();

    if (onCloseCallback) {
      onCloseCallback();
    }
  };

  getMessageParts(
    message: string,
    isSuccessMessage: boolean = false,
  ): Array<{ text: string; isEmail: boolean; email?: string }> {
    if (!isSuccessMessage) {
      return [{ text: message, isEmail: false }];
    }

    const parts = [];
    const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;
    let lastIndex = 0;
    let match;

    while ((match = emailRegex.exec(message)) !== null) {
      if (match.index > lastIndex) {
        parts.push({
          text: message.substring(lastIndex, match.index),
          isEmail: false,
        });
      }

      parts.push({
        text: match[1],
        isEmail: true,
        email: match[1],
      });

      lastIndex = match.index + match[1].length;
    }

    if (lastIndex < message.length) {
      parts.push({
        text: message.substring(lastIndex),
        isEmail: false,
      });
    }

    return parts.length > 0 ? parts : [{ text: message, isEmail: false }];
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
